import {message, Modal} from 'antd'
import {bulkUndoOnHoldOrderByIds} from "../../../../../services/api/3dApi"

const bulkUndoOnHoldByIds = async (ids) => {
    const payload = {
        ids,
    }

    const {data: response} = await bulkUndoOnHoldOrderByIds(payload)

    const {success, error} = response

    if (!success) {
        throw new Error(error)
    }

    return true
}

export default function (ids, onSuccess, onReset) {
    Modal.confirm({
        title: 'Bạn chắc chắn đánh dấu tiếp tục các orders được chọn ?',
        okText: 'Đồng ý',
        cancelText: 'Hủy',
        onOk() {
            const result = bulkUndoOnHoldByIds(ids)

            result.then(res => {
                if (res === true) {
                    message.success('Thành công!')
                    onReset()
                    onSuccess()
                }
            }).catch(err => {
                message.error(err.message, 3)
            })
        }
    })
}
